import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { ServitlyBadgePipe } from './servitly-badge.pipe';

@Pipe({ name: 'eventSeverity' })
export class EventSeverityPipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => ServitlyBadgePipe)) private syBadgePipe: ServitlyBadgePipe
    ) {
    }

    transform(value: number): string {
        const label = this.getLabel(value);
        if (this.authenticationService.isNewStyleManagerEnabled()) {
            return this.syBadgePipe.transform(label, { colorTokenPrefix: 'events', showLeadingIcon: false });
        }
        return label;
    }

    private getLabel(value: number): string {
        if (!value) {
            return 'INVALID SEVERITY';
        }
        switch (value) {
            case 1: return 'OPERATION';
            case 2: return 'MINOR ANOMALY';
            case 3: return 'MAJOR ANOMALY';
            case 4: return 'FAILURE';
            case 5: return 'MAINTENANCE'
            default: return 'INVALID SEVERITY';
        }
    }
}